/* Country-driven language fallback for the native Shopify localization form. */
(function () {
  'use strict';

  if (window.__rmCountryLanguageLoaded) return;
  window.__rmCountryLanguageLoaded = true;

  let configNode = document.getElementById('rm-country-language-config');
  let form = document.getElementById('rm-country-language-form');
  let config = {};
  try {
    config = JSON.parse(configNode ? configNode.textContent || '{}' : '{}');
  } catch (error) {
    config = {};
  }

  let available = Array.isArray(config.availableLocales)
    ? config.availableLocales.filter(function (locale) { return typeof locale === 'string'; })
    : [];
  const manualKey = 'rm_manual_locale';
  const guardPrefix = 'rm_country_language:';
  const guardLifetime = 30000;

  function isAvailable(locale) {
    return available.indexOf(locale) !== -1;
  }

  function readCookie(name) {
    let prefix = name + '=';
    try {
      return document.cookie.split(';').reduce(function (value, part) {
      let item = part.trim();
      if (item.indexOf(prefix) !== 0) return value;
      try {
        return decodeURIComponent(item.slice(prefix.length));
      } catch (error) {
        return value;
      }
      }, '');
    } catch (error) {
      return '';
    }
  }

  function writeCookie(name, value) {
    try {
      document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=31536000; samesite=lax';
    } catch (error) {
      // Cookie access can be disabled; manual selection still remains in memory.
    }
  }

  function readManualLocale() {
    try {
      let local = window.localStorage.getItem(manualKey);
      if (local) return local;
    } catch (error) {
      // Fall back to the first-party cookie below.
    }
    return readCookie(manualKey);
  }

  function persistManualLocale(locale) {
    if (!isAvailable(locale)) return;
    try {
      window.localStorage.setItem(manualKey, locale);
      return;
    } catch (error) {
      // A cookie is still useful when storage is disabled.
    }
    writeCookie(manualKey, locale);
  }

  function isLoopGuardAvailable() {
    try {
      let probe = '__rm_country_language_probe__';
      window.sessionStorage.setItem(probe, '1');
      window.sessionStorage.removeItem(probe);
      return true;
    } catch (error) {
      return false;
    }
  }

  function wasRedirectedRecently(country, locale) {
    if (!isLoopGuardAvailable()) return true;
    let key = guardPrefix + String(country || '') + ':' + locale;
    let now = Date.now();
    try {
      let previous = Number(window.sessionStorage.getItem(key) || 0);
      if (previous && now - previous < guardLifetime) return true;
      window.sessionStorage.setItem(key, String(now));
      return false;
    } catch (error) {
      return true;
    }
  }

  function setManualFromEvent(event) {
    let target = event.target;
    if (!target || !target.closest) return;
    let control = target.closest('button[lang], select[name="locale_code"], input[name="locale_code"]:not([type="hidden"])');
    if (!control) return;
    let localizationForm = control.closest('.shopify-localization-form');
    if (!localizationForm || localizationForm.id === 'rm-country-language-form') return;
    let locale = control.getAttribute('lang') || control.value;
    if (locale && isAvailable(locale)) persistManualLocale(locale);
  }

  document.addEventListener('click', setManualFromEvent, true);
  document.addEventListener('change', setManualFromEvent, true);

  function redirectWhenReady() {
    if (!config.enabled || !form || !isAvailable(config.targetLocale)) return;
    let manualLocale = readManualLocale();
    let desiredLocale = isAvailable(manualLocale) ? manualLocale : config.targetLocale;
    if (!desiredLocale || desiredLocale === config.currentLocale) return;
    if (wasRedirectedRecently(config.country, desiredLocale)) return;

    let localeInput = form.querySelector('[name="locale_code"]');
    let returnInput = form.querySelector('[name="return_to"]');
    if (!localeInput || !returnInput) return;
    localeInput.value = desiredLocale;
    returnInput.value = window.location.pathname + window.location.search + window.location.hash;
    form.submit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', redirectWhenReady, { once: true });
  } else {
    redirectWhenReady();
  }
}());
